import { actions } from '@/modules/Devis/store/actions';
import { getters } from '@/modules/Devis/store/getters';
import { mutations } from '@/modules/Devis/store/mutations';
import { state } from '@/modules/Devis/store/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { SuiviDevisState } from './state';

const module: Module<SuiviDevisState, RootState> = {
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { SuiviDevisState };
